module.exports = __webpack_public_path__ + "static/media/b63f034b.jpg";